import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function KUDIMARenunciaDeResponsabilidade() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#CB9832]/5 via-white to-[#CB9832]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-600 mb-6">
            <a href="/" className="hover:text-[#CB9832] cursor-pointer">Início</a>
            <span className="mx-2">&gt;</span>
            <span className="text-[#CB9832]">RENÚNCIA DE RESPONSABILIDADE</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-black mb-6">RENÚNCIA DE RESPONSABILIDADE</h1>
          <p className="text-lg md:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Informações legais e termos de utilização do website da +KUDIMA
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Titular do Website */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              Titular do Website
            </h2>
            <div className="bg-[#F8F8F8] rounded-2xl p-8">
              <p className="text-lg text-gray-800 mb-2 font-semibold">MAISKUDIMA – Consultoria Estratégica, Lda</p>
              <p className="text-base text-gray-700 mb-1">Rua Eduardo Mondlane, N.º 210</p>
              <p className="text-base text-gray-700 mb-3">Maianga, Luanda</p>
              <p className="text-base text-gray-700">
                E-mail: <a href="mailto:info@kudima.co.ao" className="text-[#CB9832] hover:underline cursor-pointer">info@maiskudima.com</a>
              </p>
            </div>
          </div>

          {/* Aviso Legal */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              Aviso Legal
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                A MAISKUDIMA (+KUDIMA) envida todos os esforços para garantir que as informações disponibilizadas neste website sejam rigorosas, actuais e relevantes. Contudo, não é possível assegurar que todos os conteúdos se encontrem permanentemente completos, exactos ou actualizados.
              </p>
              <p>
                As informações disponibilizadas têm carácter meramente informativo e não constituem aconselhamento técnico, jurídico, financeiro ou estratégico, salvo quando expressamente indicado.
              </p>
              <p>
                A +KUDIMA reserva-se o direito de, a qualquer momento e sem aviso prévio, alterar, actualizar ou remover conteúdos deste website.
              </p>
            </div>
          </div>

          {/* Ligações para Sites de Terceiros */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              Ligações para Sites de Terceiros
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                Este website pode conter hiperligações para páginas de terceiros. A +KUDIMA não exerce qualquer controlo sobre o conteúdo desses websites e não assume qualquer responsabilidade pelos mesmos.
              </p>
              <p>
                A existência de hiperligações não implica qualquer tipo de parceria, endosso ou recomendação dos conteúdos, serviços ou produtos disponibilizados por terceiros.
              </p>
              <p>
                Do mesmo modo, a +KUDIMA não se responsabiliza por eventuais ligações de terceiros para o seu website.
              </p>
            </div>
          </div>

          {/* Limitação de Responsabilidade */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              Limitação de Responsabilidade
            </h2>
            <div className="text-base text-gray-700 leading-relaxed">
              <p>
                A +KUDIMA exclui qualquer responsabilidade por danos directos ou indirectos, prejuízos, perdas ou interrupções resultantes do acesso, utilização ou impossibilidade de utilização deste website, excepto nos casos de actuação dolosa ou negligência grave legalmente comprovada.
              </p>
            </div>
          </div>

          {/* Direitos de Autor e Propriedade Intelectual */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              Direitos de Autor e Propriedade Intelectual
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                Todo o conteúdo deste website, incluindo textos, imagens, logótipos, marcas, gráficos, documentos, vídeos e demais materiais, encontra-se protegido por direitos de autor e demais direitos de propriedade intelectual.
              </p>
              <p>
                É permitida a utilização do conteúdo apenas para fins pessoais e não comerciais. Qualquer reprodução, distribuição, modificação ou utilização comercial carece de autorização prévia e expressa da +KUDIMA.
              </p>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-gradient-to-br from-[#2D5F3F] to-[#234A32] rounded-3xl p-10 text-center text-white">
            <h3 className="text-2xl font-bold mb-4">Tem alguma dúvida?</h3>
            <p className="text-lg mb-3 opacity-90">
              Entre em contacto connosco para esclarecimentos adicionais sobre os nossos termos e condições.
            </p>
            <a
              href="/contato"
              className="inline-block bg-[#CB9832] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#B8872D] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              CONTACTE-NOS
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}